"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = require("babel-runtime/core-js/object/define-property");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require("babel-runtime/core-js/object/entries");

var _entries2 = _interopRequireDefault(_entries);

exports.ReactiveState = ReactiveState;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Sets up a state object that can be subscribed to
 *
 * @param {Object} initialState - The initial keys we are going to be tracking
 */
function ReactiveState(initialState) {
  var _this2 = this;

  this.internalState = {};

  (0, _entries2.default)(initialState).forEach(function (_ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        key = _ref2[0],
        initialValue = _ref2[1];

    return _this2.makeKeyReactive(key, initialValue);
  });
}

/**
 * Internally we use a different key to the public key, this is just a helper to get that
 *
 * @param key {String} The key from the state tree we want
 *
 * @returns {String} The key prefixed with an `_`
 */
ReactiveState.prototype.getPrivateKey = function getPrivateKey(key) {
  return "_" + key;
};

/**
 * This allows you to add keys to be tracked after initialisation
 *
 * @param key {String} The key from the state tree we want
 * @param initialValue {*} The initial value for this key
 */
ReactiveState.prototype.addKey = function addKey(key, initialValue) {
  this.makeKeyReactive(key, initialValue);
};

/**
 * This is the magic that allows us to subscribe to state changes.
 *
 * This will take the key and add a getter and setter to it so we can notify all subscriptions
 * when the value gets set
 *
 * @param key {String} The key from the state tree we want
 * @param initialValue {*} The initial value for this key
 *
 * @returns {Object} The internal state
 */
ReactiveState.prototype.makeKeyReactive = function makeKeyReactive(key, initialValue) {
  var _this = this;
  var privateKey = this.getPrivateKey(key);

  this.internalState[privateKey] = {
    value: initialValue,
    listeners: []
  };

  (0, _defineProperty2.default)(this, key, {
    get: function get() {
      return _this.internalState[privateKey].value;
    },
    set: function set(val) {
      _this.notify(key, val, {
        prevVal: _this.internalState[privateKey].value
      });

      _this.internalState[privateKey].value = val;
    }
  });

  return this.internalState;
};

/**
 * Subscribe to a key to get notified when it's value changes
 *
 * @param key {String} The key from the state tree we want
 * @param fnc {Function} The function that will get run when the key's value changes
 */
ReactiveState.prototype.subscribe = function subscribe(key, fnc) {
  if (this.checkIfKeyInState(key)) {
    var privateKey = this.getPrivateKey(key);

    this.internalState[privateKey].listeners.push(fnc);
  }
};

/**
 * Stop getting updates when this key's value changes
 *
 * @param key {String} The key from the state tree we want
 * @param fnc {Function} The function that will get run when the key's value changes
 */
ReactiveState.prototype.unsubscribe = function unsubscribe(key, fnc) {
  if (this.checkIfKeyInState(key)) {
    var privateKey = this.getPrivateKey(key);

    /* prettier-ignore */
    this.internalState[privateKey].listeners = this.internalState[privateKey].listeners.filter(function (fn) {
      return fn !== fnc;
    });
  }
};

/**
 * This will run all of the subscribed functions to a key
 *
 * @param key {String} The key from the state tree we want
 * @param val {*} The new value
 * @param prevVal {*} The previous value
 */
ReactiveState.prototype.notify = function notify(key, val, _ref3) {
  var prevVal = _ref3.prevVal;

  if (this.checkIfKeyInState(key)) {
    var privateKey = this.getPrivateKey(key);

    this.internalState[privateKey].listeners.forEach(function (fn) {
      return fn(val, {
        prevVal: prevVal
      });
    });
  }
};

/**
 * Before we doing anything regarding keys internally we want to see if it exists
 *
 * @param key {String} The key from the state tree we want
 * @param throwError {Boolean} Whether to throw an error if the key doesn't exist
 */
ReactiveState.prototype.checkIfKeyInState = function checkIfKeyInState(key) {
  var throwError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var privateKey = this.getPrivateKey(key);
  var keyInState = privateKey in this.internalState;

  if (keyInState === false && throwError) {
    throw new Error(key + " doesn't exist in ObservableState");
  }

  return keyInState;
};